import selectCollection from "./collection"

export default function selectRawData(
  state,
  engine,
  model,
  query,
  byDefault = [],
) {
  const collection = selectCollection(state, engine, model, query)

  if (!collection) {
    return byDefault
  }

  const { data } = collection
  if (!data) {
    return byDefault
  }

  return data
}
